import api from './api';

export interface KBSubscription {
  id: string;
  client_id: string;
  client_name?: string | null;
  kb_id: string;
  kb_name?: string | null;
  status: 'active' | 'revoked';
  granted_at: string;
  granted_by: string;
  revoked_at?: string | null;
  revoked_by?: string | null;
  notes?: string | null;
}

export interface CreateKBSubscriptionRequest {
  client_id: string;
  kb_id: string;
  notes?: string | null;
}

export interface KBCatalogEntry {
  id: string;
  name: string;
  description?: string | null;
  visibility: 'shared' | 'common';
  document_count: number;
  subscribed: boolean;
}

export const kbSubscriptionService = {
  async getAll(clientId?: string, includeRevoked = false): Promise<KBSubscription[]> {
    const params = new URLSearchParams();
    if (clientId) params.set('client_id', clientId);
    if (includeRevoked) params.set('include_revoked', 'true');
    const response = await api.get<KBSubscription[]>(`/kb-subscriptions/?${params}`);
    return response.data;
  },

  async create(data: CreateKBSubscriptionRequest): Promise<KBSubscription> {
    const response = await api.post<KBSubscription>('/kb-subscriptions/', data);
    return response.data;
  },

  async revoke(subscriptionId: string): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/kb-subscriptions/${subscriptionId}`);
    return response.data;
  },

  async getForKB(kbId: string, includeRevoked = false): Promise<KBSubscription[]> {
    const params = includeRevoked ? '?include_revoked=true' : '';
    const response = await api.get<KBSubscription[]>(`/kb-subscriptions/kb/${kbId}/subscribers${params}`);
    return response.data;
  },

  async getCatalog(): Promise<KBCatalogEntry[]> {
    const response = await api.get<KBCatalogEntry[]>('/kb-subscriptions/catalog');
    return response.data;
  },
};
